var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTwotoneEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4189 13.8867C8.67798 13.8873 7.95115 13.6872 7.31795 13.3081C6.68476 12.9291 6.16961 12.3857 5.82887 11.7376H9.4189L10.0422 10.5095H5.41752C5.38635 10.3069 5.36765 10.1042 5.36765 9.89546C5.36765 9.68669 5.38635 9.48406 5.41752 9.28142H9.4189L10.0422 8.05335H5.82887C6.17016 7.40561 6.68544 6.86264 7.3185 6.48366C7.95157 6.10469 8.67812 5.90425 9.4189 5.90423C10.4224 5.90423 11.3448 6.26651 12.0553 6.86827L13.1585 5.78142C12.1321 4.87135 10.7998 4.36821 9.4189 4.36914C6.97569 4.36914 4.90644 5.91037 4.13358 8.05335H1.93968L1.31641 9.28142H3.84688C3.79663 9.68928 3.79663 10.1016 3.84688 10.5095H1.93968L1.31641 11.7376H4.13358C4.90644 13.8805 6.97569 15.4218 9.4189 15.4218C10.8587 15.4218 12.1675 14.8876 13.1585 14.0095L12.0491 12.9227C11.3448 13.5244 10.4286 13.8867 9.4189 13.8867Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5781 9.89577H16.315M13.9465 12.2642V7.52734",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTwotoneEuro);
export default __webpack_public_path__ + "static/media/ic_twotone-euro.e79f8db563766fa1bb9113366d7bc405.svg";
export { ForwardRef as ReactComponent };